import { serviceClient, site } from '@yola/ws-sdk';

const reloadSiteMeta = async () => {
  const client = serviceClient.get();
  const { data: siteMeta } = await client.getCurrentSite();
  await site.operations.reloadSiteMeta(siteMeta);
};

export default reloadSiteMeta;
